import { render, staticRenderFns } from "./OrderProcesses.vue?vue&type=template&id=8f1066d8&scoped=true"
import script from "./OrderProcesses.vue?vue&type=script&lang=js"
export * from "./OrderProcesses.vue?vue&type=script&lang=js"
import style0 from "./OrderProcesses.vue?vue&type=style&index=0&id=8f1066d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1066d8",
  null
  
)

export default component.exports